const LEGACY_APPSATIONSDK_FUNCTIONS_ORIGIN =
  "https://us-central1-studio-421455983-324bb.cloudfunctions.net";

const trimTrailingSlashes = (value: string): string => value.replace(/\/+$/, "");

const normalizeExplicitProxyBase = (value: string): string => {
  const explicit = trimTrailingSlashes(value.trim());
  if (!explicit) return "";
  if (/\/api\/github$/i.test(explicit) || /\/githubProxy$/i.test(explicit)) return explicit;
  return `${explicit}/api/github`;
};

export const resolveAppsationsSdkFunctionsOrigin = (): string => {
  const explicit = (import.meta.env.VITE_APPSATIONSDK_FUNCTIONS_ORIGIN ?? "").trim();
  if (explicit) return trimTrailingSlashes(explicit);

  const projectId = (import.meta.env.VITE_FIREBASE_PROJECT_ID ?? "").trim();
  if (projectId) {
    return `https://us-central1-${projectId}.cloudfunctions.net`;
  }

  return LEGACY_APPSATIONSDK_FUNCTIONS_ORIGIN;
};

export const buildAppsationsFunctionUrl = (functionName: string): string => {
  const normalized = functionName.trim().replace(/^\/+/, "");
  if (!normalized) return resolveAppsationsSdkFunctionsOrigin();
  if (/^https?:\/\//i.test(normalized)) return normalized;
  return `${resolveAppsationsSdkFunctionsOrigin()}/${normalized}`;
};

export const resolveAppsationsGitHubProxyBaseUrl = (): string => {
  const explicit = normalizeExplicitProxyBase(import.meta.env.VITE_GITHUB_PROXY_ORIGIN ?? "");
  if (explicit) return explicit;

  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host.endsWith(".web.app") || host.endsWith(".firebaseapp.com")) return "/api/github";
  }

  const projectId = (import.meta.env.VITE_FIREBASE_PROJECT_ID ?? "").trim();
  if (projectId) return `https://${projectId}.web.app/api/github`;

  return buildAppsationsFunctionUrl("githubProxy");
};
